import { Bug } from "lucide-react";
import { Button } from "@/components/ui/button";
import useFeedbackModal from "@/features/feedback/hooks/use-feedback-modal";
import { useI18n } from "@/locales/client";

export function DefaultErrorPage({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  const t = useI18n();
  const { onOpen } = useFeedbackModal();

  return (
    <div className="h-[calc(100vh-200px)] w-full">
      <div className="mt-8 flex flex-col items-center justify-center h-full">
        <div className="flex justify-between items-center flex-col mt-8 text-center mb-8">
          <h2 className="font-medium mb-4">{t("somethingWentWrong")}</h2>
          <p className="text-sm text-muted-foreground">
            {t("unexpectedError")}
          </p>
        </div>

        <div className="flex space-x-4">
          <Button onClick={() => reset()} variant="outline">
            {t("tryAgain")}
          </Button>

          <Button onClick={() => onOpen("bug")} className="gap-1.5">
            <Bug className="size-4" />
            {t("reportBug")}
          </Button>
        </div>
      </div>
    </div>
  );
}
